import produce from 'immer'
import { Redux } from 'types/local'
import appLoadingFeatureActions from './app-loading.actions'

export type State = Redux.UserState['appLoadingFeature']

const { types } = appLoadingFeatureActions

export const initialState: State = {
  isLoading: false,
}

export const appLoadingFeatureReducer = produce((state: State, action: Redux.Action) => {
  switch (action.type) {
    case types.SET_IS_LOADING:
      state.isLoading = action.payload
      break

    // no default
  }
}, initialState)
